/**
 * Resolve supplier contact fields for invoice display / print.
 * Merges live supplier domain data with invoice snapshots.
 */

import { translations } from './constants';

export function findSupplierById(suppliers, supplierId) {
  if (!supplierId || !Array.isArray(suppliers)) return null;
  const id = String(supplierId);
  return suppliers.find(
    (s) =>
      String(s.id || '') === id ||
      String(s.supplierId || '') === id ||
      String(s._id || '') === id
  ) || null;
}

/**
 * @param {object|null|undefined} invoice
 * @param {object[]} [suppliers]
 * @param {{ fallbackName?: string, override?: object|null }} [options]
 */
export function resolveInvoiceSupplier(invoice, suppliers = [], options = {}) {
  const { fallbackName = '—', override = null } = options;
  if (!invoice) {
    return { name: fallbackName, address: '', phone: '' };
  }

  const found = findSupplierById(suppliers, invoice.supplierId);

  return {
    name:
      override?.name ||
      override?.supplierName ||
      found?.name ||
      found?.supplierName ||
      invoice.supplierName ||
      fallbackName,
    address:
      override?.address ||
      found?.address ||
      invoice.supplierAddress ||
      '',
    phone:
      override?.phone ||
      found?.phone ||
      invoice.supplierPhone ||
      ''
  };
}

/** Strip placeholder business strings before rendering documents. */
export function formatBusinessFieldForDocument(value, placeholders = []) {
  const text = (value || '').trim();
  if (!text) return '';
  if (placeholders.some((p) => p && text === p)) return '';
  return text;
}

export function resolveBusinessInfoForDocument(businessInfo, isRTL = false) {
  const doc = translations[isRTL ? 'ar' : 'fr'].printServicePage;
  const addressPlaceholders = ['Adresse du magasin', 'العنوان غير محدد', doc.addressNotSpecified];
  const phonePlaceholders = ['Téléphone', doc.phoneNotSpecified, 'الهاتف غير محدد'];

  const address =
    formatBusinessFieldForDocument(businessInfo?.address, addressPlaceholders) ||
    doc.addressNotSpecified;
  const phone =
    formatBusinessFieldForDocument(businessInfo?.phone, phonePlaceholders) ||
    doc.phoneNotSpecified;

  return {
    name: businessInfo?.name || businessInfo?.business_name || 'AMAN',
    address,
    phone,
    email: businessInfo?.email || '',
    nif: businessInfo?.nif || null
  };
}
